export var ExprStage;
(function (ExprStage) {
    ExprStage["Const"] = "CONST";
    ExprStage["Scalar"] = "SCALAR";
    ExprStage["Analytic"] = "ANALYTIC";
    ExprStage["Aggregate"] = "AGGREGATE";
})(ExprStage || (ExprStage = {}));
